import ReactIcon from "../../icons/react-svgrepo-com (1).svg";
import Angular from "../../icons/angular-svgrepo-com.svg";
import Next from "../../icons/next-js-svgrepo-com.svg";
import Rails from "../../icons/rails-svgrepo-com.svg";
import Node from "../../icons/nodejs-icon-svgrepo-com.svg";
import Flutter from "../../icons/flutter-svgrepo-com.svg";
import Postgres from "../../icons/postgresql-svgrepo-com.svg";
import Vue from "../../icons/vue-svgrepo-com.svg";
import Mongo from "../../icons/mongodb-svgrepo-com.svg";
import JS from "../../icons/js-svgrepo-com.svg";
import Vite from "../../icons/vite-svgrepo-com.svg";
import TS from "../../icons/typescript-official-svgrepo-com.svg";
import Express from "../../icons/express-svgrepo-com.svg";
import Sinatra from "../../icons/sinatra-svgrepo-com.svg";
import Nestjs from "../../icons/nest-middleware-js-svgrepo-com.svg";
import ruby from "../../icons/ruby-svgrepo-com.svg";
import Android from "../../icons/android-color-svgrepo-com.svg";
import swift from "../../icons/swift-svgrepo-com (1).svg";
import MySql from "../../icons/mysql-svgrepo-com.svg";
import Tailwind from "../../icons/tailwind-svgrepo-com.svg";
import python from "../../icons/python-svgrepo-com.svg";
import fastapi from "../../icons/fastapi-svgrepo-com.svg";
import Prisma from "../../icons/light-prisma-svgrepo-com.svg";
import Cassandra from "../../icons/cassandra-svgrepo-com.svg";
import SQLite from "../../icons/sqlite-svgrepo-com.svg";
import dynamoDb from "../../icons/aws-dynamodb-svgrepo-com.svg";
import firebase from "../../icons/firebase-svgrepo-com.svg";
import Aws from "../../icons/aws-svgrepo-com.svg";
import GoogleCloud from "../../icons/google-cloud-svgrepo-com.svg";
import Azure from "../../icons/azure-svgrepo-com.svg";
import Heroku from "../../icons/heroku-svgrepo-com.svg";
import realm from "../../icons/realm-svgrepo-com.svg";
import pinecone from "../../icons/Pinecone-Icon--Streamline-Svg-Logos.svg";
import qdrant from "../../icons/Qdrant-Icon--Streamline-Svg-Logos.svg";
import n8n from "../../icons/n8n-svgrepo-com.svg";
import puppeteer from "../../icons/puppeteer-svgrepo-com.svg";
import playwright from "../../icons/playwright-svgrepo-com.svg";
import llamaindex from "../../icons/llamaindex-svgrepo-com.svg";
import huggingface from "../../icons/huggingface-svgrepo-com.svg";
import langchain from "../../icons/langchain-svgrepo-com.svg";
import langgraph from "../../icons/langgraph-svgrepo-com.svg";

export interface Technology {
    name: string;
    logo: string;
    path?: string;
}

export interface TechnologyCategory {
    id: number;
    title: string;
    subtitle: string;
    technologies: Technology[];
}

const technologiesData: TechnologyCategory[] = [
    {
        id: 1,
        title: "Frontend",
        subtitle:
            "Modern, responsive, and pixel-perfect interfaces built with the latest frameworks.",
        technologies: [
            { name: "React JS", logo: ReactIcon, path: "/react-js-development-company" },
            { name: "Angular JS", logo: Angular, path: "/web-development-company" },
            { name: "Next JS", logo: Next, path: "/web-development-company" },
            { name: "Vue JS", logo: Vue, path: "/web-development-company" },
            { name: "JavaScript", logo: JS, path: "/web-development-company" },
            { name: "Vite", logo: Vite, path: "/web-development-company" },
            { name: "TypeScript", logo: TS, path: "/web-development-company" },
            { name: "Tailwind CSS", logo: Tailwind, path: "/web-development-company" },
        ],
    },
    {
        id: 2,
        title: "Backend",
        subtitle:
            "Robust, scalable, and secure server-side systems powering enterprise-grade applications.",
        technologies: [
            { name: "Ruby", logo: ruby, path: "/ruby-on-rails-development-company" },
            { name: "Ruby on Rails", logo: Rails, path: "/ruby-on-rails-development-company" },
            { name: "Sinatra", logo: Sinatra, path: "/ruby-on-rails-development-company" },
            { name: "Node JS", logo: Node, path: "/custom-software-development-company" },
            { name: "Express JS", logo: Express, path: "/custom-software-development-company" },
            { name: "Nest JS", logo: Nestjs, path: "/custom-software-development-company" },
            { name: "Python", logo: python, path: "/custom-software-development-company" },
            { name: "FastAPI", logo: fastapi, path: "/custom-software-development-company" },
        ],
    },
    {
        id: 3,
        title: "Mobile",
        subtitle:
            "Native and cross-platform mobile experiences that feel fluid on every device.",
        technologies: [
            { name: "Android", logo: Android, path: "/mobile-app-development-company" },
            { name: "SwiftUI", logo: swift, path: "/mobile-app-development-company" },
            { name: "React Native", logo: ReactIcon, path: "/mobile-app-development-company" },
            { name: "Flutter", logo: Flutter, path: "/mobile-app-development-company" },
        ],
    },
    {
        id: 4,
        title: "Database",
        subtitle:
            "High-performance data stores tuned for reliability, speed, and scale.",
        technologies: [
            { name: "MySQL", logo: MySql },
            { name: "PostgreSQL", logo: Postgres },
            { name: "MongoDB", logo: Mongo },
            { name: "Firebase", logo: firebase },
            { name: "Realm", logo: realm },
            { name: "DynamoDB", logo: dynamoDb },
            { name: "Pinecone", logo: pinecone },
            { name: "Qdrant", logo: qdrant },
            { name: "Prisma", logo: Prisma },
            { name: "Cassandra", logo: Cassandra },
            { name: "SQLite", logo: SQLite },
        ],
    },
    {
        id: 5,
        title: "Cloud Services",
        subtitle:
            "Cloud-native infrastructure and CI/CD pipelines built for zero-downtime deployments.",
        technologies: [
            { name: "AWS", logo: Aws },
            { name: "Google Cloud", logo: GoogleCloud },
            { name: "Microsoft Azure", logo: Azure },
            { name: "Heroku", logo: Heroku },
        ],
    },
    {
        id: 6,
        title: "Automation",
        subtitle:
            "Workflow automation and browser testing tools for efficient, reliable processes.",
        technologies: [
            { name: "n8n", logo: n8n },
            { name: "Puppeteer", logo: puppeteer },
            { name: "Playwright", logo: playwright },
        ],
    },
    {
        id: 7,
        title: "AI Integration",
        subtitle:
            "Intelligent systems powered by the latest generative and agentic AI frameworks.",
        technologies: [
            { name: "LlamaIndex", logo: llamaindex, path: "/generative-ai-solutions-company" },
            { name: "Hugging Face", logo: huggingface, path: "/generative-ai-solutions-company" },
            { name: "LangChain", logo: langchain, path: "/ai-agent-development-company" },
            { name: "LangGraph", logo: langgraph, path: "/ai-agent-development-company" },
        ],
    },
];

export default technologiesData;
